import {keyframes} from '@emotion/react';

/** A custom hook that provides animation styles. */
const useAnimation = () => {
  const background = {
    position: keyframes({
      '0%': {
        backgroundPosition: '0% 50%',
      },
      '50%': {
        backgroundPosition: '100% 50%',
      },
      '100%': {
        backgroundPosition: '0% 50%',
      },
    }),
  } as const;

  return {background};
};

export default useAnimation;
